import { Injectable } from '@angular/core';
import { HttpOptionsModel } from '@myModels/Shared/http-options';
import { CustomHttpService } from '@myServices/custom-http.service';
import {catchError, map} from 'rxjs/operators';
@Injectable()
export class PasswordService {

  constructor(private customHttpService: CustomHttpService) { }
    changePassword(currentPassword, newPassword) {

        const postData = {
            old_password: currentPassword,
            password: newPassword
        };

        const httpOptions = new HttpOptionsModel('/site-auth/change-password', postData, true, true);
        return this.customHttpService.post(httpOptions).pipe(catchError((error) => {
            if (error.error.messages) {
                throw new Error(error.error.messages[0]);
            }
            throw new Error('UNEXPECTED_ERROR');
        }), map(resp => {
            return resp;
        }));
    }

}



// WEBPACK FOOTER //
// C:/Users/beyn/Documents/GitLab/spinmatic-casino/src/app/Modules/Shared/services/password.service.ts